import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-sales-phone-enrollment-manual-questions-process-trustonic',
  templateUrl: './sales-phone-enrollment-manual-questions-process-trustonic.component.html',
  styles: [ ]
})
export class SalesPhoneEnrollmentManualQuestionsProcessTrustonicComponent {
  visibleModalEndProcess = false;
  visibleModalQRProcess = true;

  @Output() step = new EventEmitter();

  onReturnEnrollment(){
    this.step.emit('init-enrollment-trustonic');
  }

  onProgressEnrollment(){
    this.step.emit('in-progress');
  }

}
